import { render, staticRenderFns } from "./DisciplineLessonplan.vue?vue&type=template&id=1159af2b"
import script from "./DisciplineLessonplan.vue?vue&type=script&lang=js"
export * from "./DisciplineLessonplan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports